import { styled } from 'styled-components';
import { Theme, Utils } from 'team-hero-ui';

const { flexFn, pxToRem } = Utils;

export const WrapperStyled = styled.div`
  ${flexFn()}
  gap: ${pxToRem(16)};
  padding: ${pxToRem(4)};
`;

export const WrapperContainerStyled = styled.div`
  margin-bottom: ${pxToRem(24)};
  padding: ${pxToRem([24, 0])};
`;

export const LinkStyled = styled.a`
  color: ${Theme.colors.primary.black};
`;
